module.exports = __webpack_public_path__ + "img/mobilepropertyoffice2.ad7e9bf7.png";